var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReduceBlemishes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.852,
    height: 82.064,
    viewBox: "0 0 74.852 82.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19845 19287.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.383,51.052c-.1.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.96,37.4a3.322,3.322,0,0,1,4.089.022,7.96,7.96,0,0,0,3.406,1.742,8.331,8.331,0,0,0,2.681.141,19.655,19.655,0,0,0,3.528-.847c.833-.234,1.533-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.245,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.24,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.448,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.942,19.283c.2,6.293-.736,30.857.679,36.191C11.1,64.8,22.32,73.954,29.375,78.93a9.984,9.984,0,0,0,11.674,0c2.172-1.53,4.737-3.458,7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.613,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.679,29.7a8.669,8.669,0,0,1,5.187-2.767,28.444,28.444,0,0,1,8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.06,5.618A165.334,165.334,0,0,1,48.676,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.626,47.761a1.767,1.767,0,1,1-1.767,1.767",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.482,46.625a2.04,2.04,0,1,1,2.04,2.04",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,57.237a1.759,1.759,0,1,1-1.759-1.759",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.525,51.7a2.942,2.942,0,0,1,1.589-1.256,3,3,0,0,1,2.368.286",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.282,53.809a2.937,2.937,0,0,1,1.745,1.028,3,3,0,0,1,.59,2.31",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.745,55.727a1.768,1.768,0,1,1,1.766-1.767",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.889,56.862a2.04,2.04,0,1,1-2.04-2.04",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,46.251A1.759,1.759,0,1,1,21.76,48.01",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.845,51.791a2.942,2.942,0,0,1-1.589,1.256,3,3,0,0,1-2.368-.286",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.088,49.679a2.937,2.937,0,0,1-1.745-1.028,3,3,0,0,1-.59-2.31",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-19837.059 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-19809.939 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-19797.283 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-19782.521 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-19786.469 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-19778.703 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-19776.676 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-19773.965 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-19791 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-19802.123 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.374,65.3a1.357,1.357,0,0,1-.33-.064c.028-.04.042-.062.042-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.822,25.125C6.686,28.814,1.5,32.468,1.5,39.3S3.047,48,6.574,48",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.067,43.435C66.5,46.5,65.171,46.5,63.789,46.5a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.83-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.741,30.983V15.563L5.4,14.485,26.214,3.425",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceBlemishes);
export default __webpack_public_path__ + "static/media/reduce-blemishes.f5b70ec3.svg";
export { ForwardRef as ReactComponent };